import React from 'react'

import Base from '../_Base'

const Search = (props) => (
  <Base width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      d="M9.5 2a7.5 7.5 0 0 1 5.975 12.034l6.234 6.26a1 1 0 1 1-1.418 1.412l-6.228-6.254A7.5 7.5 0 1 1 9.5 2zm0 2a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11z"
      fillRule="evenodd"
    />
  </Base>
)

export default Search
